import { TextCell } from '@common/components/TextCell';

interface CancelationReasonCellProps {
	cancelationReason?: string;
}

export const CancelationReasonCell = ({ cancelationReason }: CancelationReasonCellProps) => {
	return <TextCell value={cancelationReason} />;
};
